import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { obterSaudeLive, obterSaudeReady } from '@/features/diagnostico/api/saudeApi';
import type { RelatorioDeSaude } from '@/types/api';

export const chavesDeSaude = {
  live: ['saude', 'live'] as const,
  ready: ['saude', 'ready'] as const,
};

export function useSaudeLive(): UseQueryResult<RelatorioDeSaude> {
  return useQuery({
    queryKey: chavesDeSaude.live,
    queryFn: ({ signal }) => obterSaudeLive(signal),
    // Diagnostico: nao faz sentido servir cache velho.
    staleTime: 0,
    retry: false,
  });
}

export function useSaudeReady(): UseQueryResult<RelatorioDeSaude> {
  return useQuery({
    queryKey: chavesDeSaude.ready,
    queryFn: ({ signal }) => obterSaudeReady(signal),
    staleTime: 0,
    retry: false,
  });
}
